import utils from './../../utils.js';

export default utils.generateNamespace({
    state: [
        'LOGGING_EVENTS',
        'WAITING_FOR_RESPONSE',
        'IDS_ARRAY_OF_ROWS_WAITING_FOR_DELETE',
        'IS_SMTP_CONFIGURATION_ENABLED'
    ],
    actions: [
        'FETCH_LOGGING_EVENTS',
        'SET_UP_SERVICE',
        'HANDLE_ERROR',
        'DELETE_BY_ID',
        'CONFIRM_DELETE_ALL',
        'DELETE_LOGGING_EVENTS'
    ],
    mutations: [
        'SET_LOGGING_EVENTS',
        'DELETE_LOGGING_EVENT_BY_ID',
        'CLEAR_LOGGING_EVENTS',
        'WAIT_FOR_DELETE_RESPONSE',
        'STOP_WAIT_FOR_DELETE_RESPONSE',
        'SET_SMTP_CONFIGURATION_STATE'
    ],
    getters: [
        'LOGGING_EVENTS',
        'WAITING_FOR_RESPONSE',
        'IDS_ARRAY_OF_ROWS_WAITING_FOR_DELETE',
        'IS_SMTP_CONFIGURATION_ENABLED'
    ]
});



// WEBPACK FOOTER //
// ./src/store/modules/loggingEvents/namespace.js